import { combineReducers } from 'redux';
import login from './authentication/loginReducer';
import userCreated from './account/userCreationReducer';
import establishments from './establishment/establishmentReducer';
import establishmentUsers from './establishment/establishmentUserReducer';
import caseDatas from './caseData/caseDataReducer';
import user from './account/userReducer';
import forms from './forms/formsReducer';
import errors from './errors/errorsReducer';
import ajaxCallsInProgress from './ajaxStatusCallReducer';
import injurySummaries from './injurySummary/injurySummaryReducer';
import submissions from './submissions/submissionReducer';
import frontPageFilter from './filterFrontpageReducer';
import fileSubmission from './fileSubmission';
import statePlanStates from './statePlanStatesReducer';
import helpDeskEmail from './helpDeskReducer';
import naicsCodes from './naicsReducer';
import { routerReducer } from 'react-router-redux';

const rootReducer = combineReducers({
  login,
  userCreated,
  establishments,
  establishmentUsers,
  caseDatas,
  user,
  forms,
  errors,
  ajaxCallsInProgress,
  injurySummaries,
  submissions,
  frontPageFilter,
  fileSubmission,
  statePlanStates,
  helpDeskEmail,
  naicsCodes,
  routing:routerReducer
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/